export { default, type ButtonProps } from '../new-button/variants/default/button';
export { default as LinkButton, type LinkButtonProps } from '../new-button/variants/default/link';
export { default as IconButton, type IconButtonProps } from '../new-button/variants/icon/button';
export {
	default as LinkIconButton,
	type LinkIconButtonProps,
} from '../new-button/variants/icon/link';
export { SplitButton } from '../new-button/containers/split-button';

export type {
	Appearance,
	Spacing,
	IconProp,
	IconButtonSpacing,
	IconButtonAppearance,
} from '../new-button/variants/types';
